export default __webpack_public_path__ + "static/media/moon.85524b46.svg";